import React from 'react';
import { useTranslation } from 'react-i18next';
import WizardStep from '../WizardStep';
import { ShoppingCart, Database, Zap } from 'lucide-react';

interface WelcomeStepProps {
  onNext: () => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => {
  const { t } = useTranslation('wizard');

  return (
    <WizardStep
      title={t('welcome.title')}
      description={t('welcome.description')}
      onNext={onNext}
      nextLabel={t('welcome.nextLabel')}
      hideBack
    >
      <div className="space-y-3 text-sm text-muted-foreground">
        <div className="flex items-center gap-3">
          <ShoppingCart className="h-4 w-4 text-primary flex-shrink-0" />
          <span>{t('welcome.bullet1')}</span>
        </div>
        <div className="flex items-center gap-3">
          <Database className="h-4 w-4 text-primary flex-shrink-0" />
          <span>{t('welcome.bullet2')}</span>
        </div>
        <div className="flex items-center gap-3">
          <Zap className="h-4 w-4 text-primary flex-shrink-0" />
          <span>{t('welcome.bullet3')}</span>
        </div>
      </div>
    </WizardStep>
  );
};

export default WelcomeStep;
